
const state = {
  visible:false,
  initIdx:0,
  list: [],
}

const mutations = {
  setVisible: (state, b) => {
    state.visible = b;
  },
  setList:(state, arr)=>{
    state.list = arr;
  },
  setIdx:(state,idx)=>{
    state.initIdx=idx;
  }
}

const actions = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

